import React from 'react';
import Snackbar from '@tencent/dui/lib/components/Snackbar';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import noticeIcon from '@src/framework/editor/src/img/notice-icon.svg';
import i18n from '@i18next/i18n';

export const showTipToCopyCustomerDataToImage = (successClickCb, failClickCb) => {
    const duration = 3000;
    let isConfirm = false;
    const commonStyle = {
        verticalAlign: 'middle',
        display: 'block',
    };
    const iconStyle: any = {
        position: 'relative',
        top: '2px',
        width: '15px',
        height: '15px',
        background: `url(${noticeIcon})`,
        ...commonStyle,
    };
    const copySnackbar = Snackbar.show({
        className: 'copy-snackbar',
        message: i18n.t('剪贴板已写入'),
        action: [
            {
                text: (<div style={{ color: '#1e6fff', ...commonStyle }}>{i18n.t('粘贴到其他应用')}</div>),
                onClick: () => {
                    isConfirm = true;
                    copySnackbar.close();
                    successClickCb();
                },
            },
            {
                text: (<Tooltip title={i18n.t('由于浏览器的限制，点击「粘贴到其他应用」按钮，可将复制/剪切的内容带格式粘贴到其他应用。')}><i style={iconStyle}></i></Tooltip>),
                onClick: () => copySnackbar.show(),
            },
        ],
        type: 'success',
        autoClose: true,
        duration,
        closable: true,
        onClose: () => !isConfirm && failClickCb('User actively denied permission'),
    });
    setTimeout(() => failClickCb('Waiting time is too long and permission is not obtained'), duration);
};

export const showTipWhenDataNotReady = () => Snackbar.show({
    message: i18n.t('加载幻灯片中，请稍后再试'),
    type: 'info',
    autoClose: true,
});

export const showTipWhenIsSmartArt = () => Snackbar.show({
    message: i18n.t('smartArt暂不支持复制,请转化成组合'),
    type: 'info',
    autoClose: true,
});

// copy单个音视频元素时提示
export const showTipWhenCopyMedia = (sdkData) => {
    if (sdkData?.audio || sdkData?.video) {
        Snackbar.show({
            message: i18n.t('音视频暂不支持复制，将粘贴为图片。'),
            type: 'info',
            autoClose: true,
        });
    }
};

export const showTipWhenChart = (sdkData) => {
    if (sdkData?.image?.chartRelation || sdkData?.image?.chartStaticFolder) {
        Snackbar.show({
            message: i18n.t('图表暂不支持复制，将粘贴为图片。'),
            type: 'info',
            autoClose: true,
        });
    }
};
